module.exports = __webpack_public_path__ + "fonts/GothamSSm-Bold.bf7a7167.eot";